var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCylinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 16.0998C0.799805 7.49982 16.8997 0.799805 37.3997 0.799805C57.8997 0.799805 73.9998 7.49982 73.9998 16.0998C73.9998 16.6575 73.9321 17.2073 73.7998 17.7477V62.1998C73.9998 70.7997 57.8997 77.4998 37.3997 77.4998C16.8997 77.4998 0.799805 70.7997 0.799805 62.1998V16.0998ZM3.59985 22.0823C9.06836 27.6146 21.991 31.3998 37.3997 31.3998C52.6235 31.3998 65.4209 27.7048 70.9998 22.2806V62.1998C70.9998 68.1998 57.4998 74.5998 37.2998 74.5998C17.1997 74.5998 3.59985 68.1998 3.59985 62.1998V22.0823ZM71.0999 16.0998C71.0999 10.0998 57.5996 3.69983 37.3997 3.69983C17.1997 3.69983 3.69971 10.0998 3.69971 16.0998C3.69971 22.0998 17.2996 28.4998 37.3997 28.4998C56.5911 28.4998 69.7351 22.7228 70.9998 17.0005V16.0998H71.0999Z",
    fill: "#1B3E6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinder);
export default __webpack_public_path__ + "static/media/Cylinder.132dd00497c650b59940f52073908644.svg";
export { ForwardRef as ReactComponent };